// webb header links
import { useState } from "react";
import { Link } from "react-router-dom";

import { UserForm } from "../../services/srvc-utilities";
// import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { ActiveSiteLink } from '../../services/srvc-utilities';

import { Row, Col, Space, Typography } from 'antd';

const { Text } = Typography;

const list = (require("../../data/navs-vault.json")).data;

export default function NavsVault(props) {

  const data = Array.from(list, item => {return {...item, stat: false}})
  
  const [sort, setSort] = useState('Artworks');

  const handleSort = async(item) => {
    console.log (item)
    setSort(item);
    props.sort(item.toLowerCase());
  }

  return (
  <>
    <div className="border-bottom mb-2"></div>
    <div className="text-center">
      <Space className="" >
        
        {data && data.map((item, i) => (
          <Row align="middle" 
            className={`cursor hilite p-1 px-2 rounded-xx text-color-${sort === item.name ? 'main' : 'tone'}`}
            onClick={() => {handleSort(item.name)}}
            key={i}
          >

            <i className={`${item.icon}`} style={{fontSize:'1rem'}}></i>
            <span className="ms-1">{item.name}</span> 

          </Row>
        ))}
      
      </Space>
    </div>
    <div className="border-bottom mt-2"></div>
  </>
  )
}